import { Admin } from "@/models/admin";

export class TicketAssignedAdmin {
	id:number;
	ticketId:number;
	adminId:number;
	admin?:Admin;

	constructor(data:any) {
		this.id = data.id;
		this.ticketId = data.ticketId;
		this.adminId = data.adminId;
		if (data.admin) {
			this.admin = new Admin(data.admin);
		}
	}
}